export const GET_SCHEDULE_OTP_CODE_START = 'GET_SCHEDULE_OTP_CODE_START';

export const GET_SCHEDULE_OTP_CODE_SUCCESS = 'GET_SCHEDULE_OTP_CODE_SUCCESS';

export const GET_SCHEDULE_OTP_CODE_FAILURE = 'GET_SCHEDULE_OTP_CODE_FAILURE';
